import { Routes, Route, NavLink } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import appRoutes from "./routes";
import { lazy } from "react";
import Logout from "./pages/Logout";

const LoginPage = lazy(() => import("./pages/LoginPage"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Users = lazy(() => import("./pages/Users"));
const AddUser = lazy(() => import("./pages/AddUser"));
const Trainers = lazy(() => import("./pages/Trainers"));
const CreateTrainer = lazy(() => import("./pages/CreateTrainer"));
const AssignSubscriptionPlan = lazy(() => import("./pages/AssignSubscriptionPlan"));
const UserDetails = lazy(() => import("./pages/UserDetails"));
const UserEdit = lazy(() => import("./pages/UserEdit"));
const UserSuspend = lazy(() => import("./pages/UserSuspend"));
const UserDelete = lazy(() => import("./pages/UserDelete"));
const TrainerPayments = lazy(() => import("./pages/TrainerPayments"));
const TrainerApproval = lazy(() => import("./pages/TrainerApproval"));
const TrainerReject = lazy(() => import("./pages/TrainerReject"));
const Formations = lazy(() => import("./pages/Formations"));
const FeaturedFormations = lazy(() => import("./pages/FeaturedFormations"));
const Coaching = lazy(() => import("./pages/Coaching"));
const CoachingOfferBookings = lazy(() => import("./pages/CoachingOfferBookings"));
const Feedbacks = lazy(() => import("./pages/Feedbacks"));
const CoinAttributions = lazy(() => import("./pages/CoinAttributions"));
const FormationDetails = lazy(() => import("./pages/FormationDetails"));
const CourseDetails = lazy(() => import("./pages/CourseDetails"));
const Orders = lazy(() => import("./pages/Orders"));
const Cockpit = lazy(() => import("./pages/Cockpit"));
const Categories = lazy(() => import("./pages/Categories"));
const AddCategory = lazy(() => import("./pages/AddCategory"));
const SubscriptionPlans = lazy(() => import("./pages/SubscriptionPlans"));
const AddEditSubscriptionPlan = lazy(() => import("./pages/AddEditSubscriptionPlan"));
const StripeSubscriptionTrialTest = lazy(() => import("./pages/StripeSubscriptionTrialTest"));
const CertificationCriteria = lazy(
  () => import("./pages/CertificationCriteria"),
);
const PaymentOptions = lazy(() => import("./pages/PaymentOptions"));
const CertificationRequests = lazy(
  () => import("./pages/CertificationRequests"),
);
const CertificationReviewQueue = lazy(
  () => import("./pages/CertificationReviewQueue"),
);

// TODO: add to dashboard:Commission coaching, commission plans, revenu abonnement plans
// TODO: remove from dashboard Dernières inscriptions à enlever du tableau de bord
// TODO: Enlèver la colonne stripe côté commande / remboursement que Stripe fait. Taux de conversion a enlevé
// TODO: Rajouter la section des revenus abonnement

function App() {
  return (
    <Routes>
      <Route path={appRoutes.logout} element={<Logout />} />
      {/* ############################################### Public routes ############################################### */}
      <Route
        path={appRoutes.public.login}
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />

      {/* ############################################### Protected routes ############################################### */}
      <Route
        path={appRoutes.protected.dashboard}
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.categories}
        element={
          <ProtectedRoute>
            <Categories />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.categoryDetail.labelRoute}
        element={
          <ProtectedRoute>
            <AddCategory />
          </ProtectedRoute>
        }
      />
        <Route
            path={appRoutes.protected.subscriptionPlanDetail.labelRoute}
            element={
                <ProtectedRoute>
                    <AddEditSubscriptionPlan />
                </ProtectedRoute>
            }
        />
      <Route
        path={appRoutes.protected.subscriptionPlan}
        element={
          <ProtectedRoute>
            <SubscriptionPlans />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.users}
        element={
          <ProtectedRoute>
            <Users />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.addUser}
        element={
          <ProtectedRoute>
            <AddUser />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.trainers}
        element={
          <ProtectedRoute>
            <Trainers />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.certificationCriteria}
        element={
          <ProtectedRoute>
            <CertificationCriteria />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.paymentOptions}
        element={
          <ProtectedRoute>
            <PaymentOptions />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.certificationRequests}
        element={
          <ProtectedRoute>
            <CertificationRequests />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.certificationReviewQueue}
        element={
          <ProtectedRoute>
            <CertificationReviewQueue />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.createTrainer}
        element={
          <ProtectedRoute>
            <CreateTrainer />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.assignSubscriptionPlan.labelRoute}
        element={
          <ProtectedRoute>
            <AssignSubscriptionPlan />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.userDetail.labelRoute}
        element={
          <ProtectedRoute>
            <UserDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.userEdit.labelRoute}
        element={
          <ProtectedRoute>
            <UserEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.userSuspend.labelRoute}
        element={
          <ProtectedRoute>
            <UserSuspend />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.userDelete}
        element={
          <ProtectedRoute>
            <UserDelete />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.trainerPayments.labelRoute}
        element={
          <ProtectedRoute>
            <TrainerPayments />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.trainerApproval.route}
        element={
          <ProtectedRoute>
            <TrainerApproval />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.trainerReject}
        element={
          <ProtectedRoute>
            <TrainerReject />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.formations}
        element={
          <ProtectedRoute>
            <Formations />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.featuredFormations}
        element={
          <ProtectedRoute>
            <FeaturedFormations />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.coaching}
        element={
          <ProtectedRoute>
            <Coaching view="offers" />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.coachingCancelled}
        element={
          <ProtectedRoute>
            <Coaching view="cancelled" />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.coachingOfferBookings.labelRoute}
        element={
          <ProtectedRoute>
            <CoachingOfferBookings />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.feedbacks}
        element={
          <ProtectedRoute>
            <Feedbacks />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.coinAttributions}
        element={
          <ProtectedRoute>
            <CoinAttributions />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.formationDetail.labelRoute}
        element={
          <ProtectedRoute>
            <FormationDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.courseDetail}
        element={
          <ProtectedRoute>
            <CourseDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.orders}
        element={
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.cockpit}
        element={
          <ProtectedRoute>
            <Cockpit />
          </ProtectedRoute>
        }
      />
      <Route
        path={appRoutes.protected.stripeSubscriptionTest}
        element={
          <ProtectedRoute>
            <StripeSubscriptionTrialTest />
          </ProtectedRoute>
        }
      />
      <Route
        path="*"
        element={
          <div className="text-5xl font-bold h-screen flex flex-col items-center justify-center gap-5 bg-primary/50">
            <h1>Oops...</h1>
            <h1>404</h1>
            <p>Cette page n&apos;existe pas</p>
            <NavLink
              className="text-2xl text-blue-800 hover:underline"
              to={appRoutes.protected.dashboard}
            >
              Go to dashboard page
            </NavLink>
          </div>
        }
      />
    </Routes>
  );
}

export default App;
